import { Checkbox } from '@cutilei/ui'

/*
  Caixa de marcar, sobre o Checkbox do @cutilei/ui (16 px, quadrado), com as props de antes do Design
  System: `value` é o estado, e `onValueChange(marcado)` recebe o novo valor. A tela continua dando o
  nome pela própria <label>, com `htmlFor` apontando para o `id` ou envolvendo a caixa, e clicar na
  label também marca.

  O `style` passa direto: as telas usam margens e, nos cartões, `position: absolute`. Os 5 px de
  margem à direita do componente antigo continuam como padrão.
*/
export default function CheckBox({
  id,
  value,
  onValueChange,
  disabled = false,
  style
}) {
  return (
    <Checkbox
      id={id}
      checked={Boolean(value)}
      onCheckedChange={onValueChange}
      disabled={disabled}
      style={{ marginRight: 5, ...style }}
    />
  )
}
